export const validateEmail = (emailContacto: string): boolean => {
    // Expresión regular para verificar el correo electrónico
    const regex = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;
console.log(emailContacto)
    // Comprobar si el emailContacto cumple con la expresión regular
    return regex.test(emailContacto);
}
  